import { useEffect, useContext, useRef } from 'react';
import { currentSearch } from '../contexts/Search';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Search from '../components/Search';
import Post from '../components/Post';
import Loading from '../components/Loading';
import NoResults from '../components/NoResults';
import { renderPagination } from '../components/Pagination';
import Unauth from '../components/Unauth';
import { CurrentUser } from '../contexts/CurrentUser';

function SearchPage() {
    const { isLoggedIn } = useContext(CurrentUser);
    const scrollPanel = useRef();
    const { results: { meta = {}, rows = [] }, isLoading } = useContext(currentSearch);
    const { pages = 0, total = 0 }= meta;

    useEffect(() => {
        const { current } = scrollPanel || {};
        if (current) {
            current.scrollTop = 0;
        }

    }, [rows, scrollPanel]);

    if (!isLoggedIn) {
        return <Unauth/>
    }

    return (
        <Container className='search-container'>
            <Row className='input-container'>
                <Search />
            </Row>
            <Row className={pages <= 1 ? 'scroll-container' : 'scroll-container-search'} ref={scrollPanel}>
                <div className='search-results'>
                    <div className='posts'>
                        {
                            isLoading ?
                                <Loading />
                                :
                                total ?
                                    rows.map((post) => {
                                        return <Post key={post.id} post={post} />
                                    })
                                    :
                                    <NoResults />

                        }
                    </div>
                </div>
            </Row>
            {renderPagination(meta)}
        </Container>

    )
}

export default SearchPage;